import { render, staticRenderFns } from "./RegisterHotel.vue?vue&type=template&id=08a67ead"
import script from "./RegisterHotel.vue?vue&type=script&lang=js"
export * from "./RegisterHotel.vue?vue&type=script&lang=js"
import style0 from "./RegisterHotel.vue?vue&type=style&index=0&id=08a67ead&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports